import { QuantityUnit, SizeUnit, WeightUnit } from 'src/app/shared/models/unit.models';
import { IDocument } from '../../customers/models/customer-document.models';
import { ICustomer } from '../../customers/models/customer.models';

export interface IArticle {
    itemNo: string;
    itemNoExternal: string | null;
    name: string | null;
    note: string | null;
    type: Type;
    procurementType: ProcurementType;
    id: string;
    version: string | null;
    partDetails: IPartDetails;
    customer?: ICustomer;
}

export interface IArticleRequest {
    itemNo: string | null;
    itemNoExternal: string | null;
    name: string;
    note: string | null;
    procurementType: ProcurementType;
    type: Type;
    drawingFileId: string | null;
    previewImageId: string | null;
    rawMaterialId: string | null;
    customerId: string | null;
    productionSteps: string[] | null;
    weight: number | null;
    quantityUnit: QuantityUnit | null;
    defaultVat: number | null;
    basePrice: number | null;
}

export enum ArticleSystemManagedPurpose {
    TransportItem = 'TransportItem',
    DownPaymentInvoicePosition = 'DownPaymentInvoicePosition',
    ShippingCostInvoicePosition = 'ShippingCostInvoicePosition',
}

export interface IArticleResponse {
    id: string;
    version: string | null;
    partDetails: IPartDetails;
    customer: ICustomer;
    documents: IDocument;
    itemNo: string;
    itemNoExternal: string | null;
    name: string;
    note: string | null;
    type: Type;
    procurementType: ProcurementType;
    systemManagedPurpose?: ArticleSystemManagedPurpose | null;
}

export enum ProductionStep {
    Punching = 'Punching',
    LaserCutting = 'LaserCutting',
    TubeCutting = 'TubeCutting',
    Deburring = 'Deburring',
    SurfaceTreatment = 'SurfaceTreatment',
    Bending = 'Bending',
    Welding = 'Welding',
    Painting = 'Painting',
    Assembling = 'Assembling',
}

export interface IPartDetails {
    id?: string;
    length: null | number;
    width: null | number;
    height: null | number;
    sizeUnit: SizeUnit | null;
    drawingNo: null | string;
    drawingFileId?: string | null;
    previewImageId?: string | null;
    rawMaterialId: null | string;
    rawMaterialName: null | string;
    productionSteps: ProductionStep[];
    hasImagePreview: boolean;
    hasStlPreview: boolean;
    hasSvgPreview: boolean;
    weight: number | null;
    weightUnit: WeightUnit | null;
    quantityUnit: QuantityUnit | null;
    defaultVat: number | null;
    basePrice: number | null;
}

export enum ProcurementType {
    Unknown = 'Unknown',
    Manufacture = 'Manufacture',
    Purchase = 'Purchase',
}

export enum Type {
    Part = 'Part',
    Assembly = 'Assembly',
    Sheet = 'Sheet',
    Tube = 'Tube',
    Other = 'Other',
}

export enum PreviewType {
    Image = 'Image',
    Svg = 'Svg',
    Stl = 'Stl',
}
